import { Edge } from 'reactflow'

export const nodeHasChildren = (edges: Edge[], currentNodeId: string): boolean => {
  return edges.some((edge) => edge.source === currentNodeId)
}
